import axios from "@/plugins/axios";

let url = "/api/console/common/files";

export default {
    post({ _notification, index }, file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        if (_notification) formData.append("_notification", _notification);
        if (index !== undefined) formData.append("index", index);
        formData.append("file", file);
        return axios.post(url, formData, { headers }).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
};
